import { HisWidgetBase } from './his-widget-base';

export class HisInputWidget extends HisWidgetBase<string> {
    kind = 'input';
    type: string;
    multiSearchCriterion?: string;
    multiSearchCriterionLabels?: string;
    placeholder?: string;

    constructor( options: any = {} ) {
        super( options );

        this.type = options.type || 'text';
        this.multiSearchCriterion = options.multiSearchCriterion;
        this.multiSearchCriterionLabels = options.multiSearchCriterionLabels;
        this.placeholder = options.placeholder;
    }

    isWidgetModified(): boolean {
        if ( this.value === '' || this.value === null ) {
            this.value = undefined;
        }

        if ( this.originalValue === '' || this.originalValue === null ) {
            this.originalValue = undefined;
        }

        return this.value !== this.originalValue;
    }
}
